"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var estilosDatePicker = require("./DatePicker.module.scss");
var react_1 = __importStar(require("react"));
var DatePickerCabecalho_1 = require("./DatePickerCabecalho/DatePickerCabecalho");
var DatePickerCorpo_1 = require("./DatePickerCorpo/DatePickerCorpo");
var today = new Date();
var diaAtual = today.getDate().toString();
var mesAtual = (today.getMonth() + 1).toString();
var anoAtual = today.getFullYear().toString();
var DatePicker = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? true : _b, _c = _a.dia, dia = _c === void 0 ? diaAtual : _c, _d = _a.mes, mes = _d === void 0 ? mesAtual : _d, _e = _a.ano, ano = _e === void 0 ? anoAtual : _e, _f = _a.cabecalhoDatePicker, cabecalhoDatePicker = _f === void 0 ? "mes/ano" : _f, _g = _a.corpoDatePicker, corpoDatePicker = _g === void 0 ? "dia" : _g, onDataSelecionada = _a.onDataSelecionada;
    var anoAjustado = ano;
    if (ano.length === 2) {
        var anoNumero = parseInt(ano, 10);
        anoAjustado = anoNumero >= 50 ? "20".concat(anoAjustado) : "19".concat(anoAjustado);
    }
    var mesInicial = parseInt(mes);
    var anoInicial = parseInt(anoAjustado, 10);
    var diaInicial = parseInt(dia, 10);
    //TO DO
    // const [datePickerCorpo, setDatePickerCorpo] = useState<TipoCorpoDatePicker>(corpoDatePicker);
    // const [datePickerCabecalho, setDatePickerCabecalho] = useState<TipoCabecalho>(cabecalhoDatePicker);
    var _h = (0, react_1.useState)(diaInicial), diaSelecionado = _h[0], setDiaSelecionado = _h[1];
    var _j = (0, react_1.useState)(mesInicial), mesSelecionado = _j[0], setMesSelecionado = _j[1];
    var _k = (0, react_1.useState)(anoInicial), anoSelecionado = _k[0], setAnoSelecionado = _k[1];
    var _l = (0, react_1.useState)({
        dia: parseInt(dia),
        mes: parseInt(mes),
        ano: parseInt(ano),
    }), dataSelecionada = _l[0], setDataSelecionada = _l[1];
    var handleRetornaUmAno = function () {
        setMesSelecionado(function (prevMesSelecionado) {
            var novoMes = (prevMesSelecionado - 12);
            var mesCorrigido = novoMes;
            var novoAno = anoSelecionado;
            if (novoMes < 1) {
                mesCorrigido += 12;
                novoAno -= 1;
            }
            setAnoSelecionado(novoAno);
            return mesCorrigido === 0 ? 12 : mesCorrigido;
        });
    };
    var handleMesAnterior = function () {
        var novoMes = mesSelecionado === 1 ? 12 : mesSelecionado - 1;
        var novoAno = mesSelecionado === 1 ? anoSelecionado - 1 : anoSelecionado;
        setMesSelecionado(novoMes);
        setAnoSelecionado(novoAno);
    };
    var handleProximoMes = function () {
        var novoMes = mesSelecionado === 12 ? 1 : mesSelecionado + 1;
        var novoAno = mesSelecionado === 12 ? anoSelecionado + 1 : anoSelecionado;
        setMesSelecionado(novoMes);
        setAnoSelecionado(novoAno);
    };
    var handleAvancaUmAno = function () {
        setMesSelecionado(function (prevMesSelecionado) {
            var novoMes = (prevMesSelecionado + 12);
            var mesCorrigido = novoMes;
            var novoAno = anoSelecionado;
            if (novoMes >= 12) {
                mesCorrigido -= 12;
                novoAno += 1;
            }
            setAnoSelecionado(novoAno);
            return mesCorrigido === 0 ? 12 : mesCorrigido;
        });
    };
    var handlePrimeiroAno = function () {
        setAnoSelecionado(function (prevAno) { return prevAno - 12; });
    };
    var handleAnoAnterior = function () {
        setAnoSelecionado(anoSelecionado - 1);
    };
    var handleProximoAno = function () {
        setAnoSelecionado(anoSelecionado + 1);
    };
    var handleUltimoAno = function () {
        setAnoSelecionado(function (prevAno) { return prevAno + 12; });
    };
    var handleDiaClick = (0, react_1.useCallback)(function (dia, pertenceAoMesSelecionado) {
        if (pertenceAoMesSelecionado) {
            setDataSelecionada({
                dia: dia,
                mes: mesSelecionado,
                ano: anoSelecionado,
            });
            onDataSelecionada(String(dia), String(mesSelecionado), String(anoSelecionado));
        }
        else {
            if (dia > 15) {
                handleMesAnterior();
            }
            else {
                handleProximoMes();
            }
        }
    }, [mesSelecionado, anoSelecionado, onDataSelecionada]);
    var handleMesClick = (0, react_1.useCallback)(function (mes) {
        setMesSelecionado(mes);
        onDataSelecionada(undefined, String(mes));
    }, [onDataSelecionada]);
    var handleAnoClick = (0, react_1.useCallback)(function (ano) {
        onDataSelecionada(undefined, String(mesSelecionado), String(ano));
    }, [onDataSelecionada]);
    (0, react_1.useEffect)(function () {
        setDiaSelecionado(diaInicial);
        setMesSelecionado(mesInicial);
        setAnoSelecionado(anoInicial);
        setDataSelecionada({
            dia: diaInicial,
            mes: mesInicial,
            ano: anoInicial,
        });
    }, [mes, ano, dia]);
    return (isOpen && (react_1.default.createElement("div", { className: estilosDatePicker.container },
        react_1.default.createElement(DatePickerCabecalho_1.DatePickerCabecalho, { mes: mesSelecionado, ano: anoSelecionado, cabecalhoDatePicker: cabecalhoDatePicker, corpoDatePicker: corpoDatePicker, onPrimeiro: corpoDatePicker === "ano"
                ? handlePrimeiroAno
                : handleRetornaUmAno, onAnterior: corpoDatePicker === "dia"
                ? handleMesAnterior
                : handleAnoAnterior, onProximo: corpoDatePicker === "dia"
                ? handleProximoMes
                : handleProximoAno, onUltimo: corpoDatePicker === "ano"
                ? handleUltimoAno
                : handleAvancaUmAno, onClickMes: function () { }, onClickAno: function () { }, onChange: function () { }, onClick: function () { } }),
        react_1.default.createElement(DatePickerCorpo_1.DatePickerCorpo, { corpoDatePicker: corpoDatePicker, dia: String(diaSelecionado), mes: String(mesSelecionado), ano: String(anoSelecionado), diaClicado: function (dia, pertenceAoMesSelecionado) {
                return handleDiaClick(parseInt(dia, 10), pertenceAoMesSelecionado);
            }, dataSelecionada: {
                dia: String(dataSelecionada.dia),
                mes: String(dataSelecionada.mes),
                ano: String(dataSelecionada.ano),
            }, mesClicado: function (mes) { return handleMesClick(parseInt(mes)); }, anoClicado: function (ano) { return handleAnoClick(parseInt(ano)); } }))));
};
exports.DatePicker = DatePicker;
